import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { CreditRecoveryDetailsPresentation } from "./components/CreditRecoveryDetailsPresentation";

export const CreditRecoveryDetailsPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<CreditRecoveryDetailsPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
